import { render, staticRenderFns } from "./CopyFeaturesModal.vue?vue&type=template&id=6ffd65b6"
import script from "./CopyFeaturesModal.vue?vue&type=script&lang=js"
export * from "./CopyFeaturesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports